// (создайте если нет)
export const TEST_STATUS_STYLES = {
    RUNNING: { backgroundColor: "#4574D2", color: "#fff" },
    PENDING: { backgroundColor: "#F0AD4E", color: "#fff" },
    COMPLETED: { backgroundColor: "#198754", color: "#fff" },
    FAILED: { backgroundColor: "#D32F2F", color: "#fff" },
    INITIAL_FAILURE: { backgroundColor: "#8E1515", color: "#fff" }, 
    Draft: { backgroundColor: "#6D6E6F", color: "#fff" },
};
